import Vue from 'vue';
import Vuex from 'vuex';
import supabase from "@/lib/supabaseClient";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        myLocations: [],
        topLocations: [],
        hotSpots: [],
        userData: {},
        userCardLoaded: false,
        onboardingDialogVisible: false,
        loading: true,
        addedLocationName: null,
        locationAddedDialogVisible: false,
        profileDialogVisible: false,
        /*profileDialogData: {},*/
        profileDialogDepartureDate: null,
        mainMapCenter: {
            lat: 27.7837304,
            lng: 16.4458825
        },
        mainMapZoom: 3,
        locationNomads: [],
        topLocationDialogVisible: false,
        topLocationDialogLocation: {},
        addLocationErrorAlert: false,
        hotspotType: 'nomads choice',
        usersList: null,
        searchTerms: [],
        profileCardData: {},
        socialData: [],
        socialEventData: null,
        socialEventDialogVisible: false,
        hotSpotsChipsState: false,
        viewsMapCenter: [
            {lat: 27.7837304, lng: 16.4458825},
            {lat: 27.7837304, lng: 16.4458825},
            null,
            {lat: 27.7837304, lng: 16.4458825},
            {lat: 27.7837304, lng: 16.4458825},
        ],
        viewsMapZoom: [3,3,14,3,3],
        aboutDialogVisible: false,
        eventsVisible: true,
        stillHereDialogVisible: false,
        currentMapBounds: null,
        likedHotspots: [],
        userHotspotLikes: [],
        userContributions: [],
        addContributionVisible: false,
        contributionToEdit: null,
        exploreViewVisible: false
    },
    mutations: {
        setExploreViewVisibility(state, data) {
            state.exploreViewVisible = data
        },
        setContributionToEdit(state, data) {
            state.contributionToEdit = data
        },
        setAddContributionVisibility(state, data) {
            state.addContributionVisible = data
        },
        setMapBounds(state, data) {
            state.currentMapBounds = data
        },
        setViewsMapCenter(state, data) {
            state.viewsMapCenter[data.view] = data.value
        },
        setViewsMapZoom(state, data) {
            state.viewsMapZoom[data.view] = data.value
        },
        setAboutDialogVisibility(state, data) {
            state.aboutDialogVisible = data
        },
        toggleEventsVisibility(state) {
            state.eventsVisible = !state.eventsVisible
        },
        setStillHereDialogVisibility(state, data) {
            state.stillHereDialogVisible = data
        },
        pickHotspotType(state, data) {
            state.hotspotType = data
        },
        changeMapCenter(state, data) {
            state.mainMapCenter = data
        },
        changeMapZoom(state, data) {
            state.mainMapZoom = data
        },
        addLocationErrorAlertOn(state) {
            state.addLocationErrorAlert = true
        },
        profileDialogOn(state) {
            state.profileDialogVisible = true
        },
        profileDialogOff(state) {
            state.profileDialogData = {}
            state.profileDialogVisible = false
        },
        closeOnboardingDialog(state) {
            state.onboardingDialogVisible = false
        },
        loadingOn(state) {
            state.loading = true
        },
        loadingOff(state) {
            state.loading = false
        },
        eventDialogOff(state) {
            state.socialEventDialogVisible = false
        },
        handleAddedLocationDialog(state, data) {
            state.addedLocationName = data
            state.locationAddedDialogVisible = true
        },
        getUserData(state, data) {

            state.userData.userId = data[0].id
            state.userData.userEmail = data[0].email
            state.userData.userInitials = data[0].initials
            state.userData.profilePictureUrl = data[0].avatar_url
            state.userData.userFullName = data[0].full_name
            state.userData.originCountry = data[0].origin_country
            state.userData.facebookAccount = data[0].facebook_account
            state.userData.instagramAccount = data[0].instagram_account

            state.userData.privacyDefault = data[0].privacy_default
            state.userCardLoaded = true
            /*
                        this.isPublicStay = data[0].privacy_default
            */

            const current_stay = data[0].current_stay || null
            if (current_stay) {
                state.userData.currentStayDates = [current_stay.arrival_date, current_stay.departure_date]
                state.userData.currentStayLocation = current_stay.locations.name
                state.userData.currentStayPosition = current_stay.locations.position
                state.userData.currentStayLocationId = current_stay.locations.id
                state.userData.currentStayTense = current_stay.tense
                state.userData.currentStayId = current_stay.id
                state.userData.currentStayLastUpdated = current_stay.last_updated

                state.viewsMapCenter[2] = current_stay.locations.position

            }
        },
        changeHotSpotsChipsState(state, data) {
            state.hotSpotsChipsState = data;
        },
        getMyLocations(state, data) {
            state.myLocations = data;
        },
        getUsersList(state, data) {
            state.usersList = data;
        },
        getTopLocations(state, data) {
            state.topLocations = data;
        },
        getHotSpots(state, data) {
            state.hotSpots = data;
        },
        setProfileCardData(state, data) {
            state.profileCardData = data;
        },
        setSocialData(state, data) {
            state.socialData = data;
        },
        initLocationDialog(state, {data, location}) {
            state.locationNomads = data;
            state.topLocationDialogLocation = location;
            state.topLocationDialogVisible = true;
        },
        closeLocationDialog(state) {
            state.topLocationDialogVisible = false;
        },
        setSocialEvent(state, data) {
            state.socialEventData = data;
            state.socialEventDialogVisible = true;
        },
        getSearchTerms(state) {
            const normalizedUsers = state.usersList.map(user => ({
                name: user.full_name,
                pic_url: user.avatar_url,
                id: user.id,
                type: 'user' // Adding a type field to indicate this is a user
            }));

            // Map over the locations array to transform its objects
            const normalizedLocations = state.topLocations.map(location => ({
                ...location, // Spread operator to copy all existing fields
                type: 'location' // Adding a type field to indicate this is a location
            }));

            const normalizedSocialData = state.socialData.map(post => ({
                name: post.short_title,
                pic_url: post.location_id.pic_url,
                id: post.id,
                type: 'social' // Adding a type field to indicate this is a location
            }));

            // Combine the two arrays
            state.searchTerms = [...normalizedUsers, ...normalizedLocations, ...normalizedSocialData].sort((a, b) => {
                // Compare the name fields for sorting
                return a.name.localeCompare(b.name);
            });
        },
        setLikedHotspots(state, data) {
            state.likedHotspots = data;
        },
        setUserHotspotLikes(state, data) {
            state.userHotspotLikes = data;
        },
        setUserContributions(state, data) {
            state.userContributions = data;
        }
    },
    actions: {
        async getLikedHotspots({ commit }) {
            try {
                const { data, error } = await supabase
                    .from("hotspots")
                    .select("id, name, position, likes, rating, user_ratings_total")
                    .gt("likes", 0);

                if (error) {
                    console.error("Error fetching LikedHotspots from Supabase:", error);
                    return;
                }
                // replace "position" with "geometry.location"
                data.forEach((hotspot) => {
                    hotspot.geometry = {
                        location: hotspot.position
                    }
                    hotspot.place_id = hotspot.id
                    delete hotspot.id
                    delete hotspot.position
                })
                // sort by likes
                data.sort((a, b) => b.likes - a.likes);
                commit('setLikedHotspots', data);
            } catch (error) {
                console.error("An error occurred while fetching locations:", error);
            }
        },
        async getUserLikes({ commit }) {
            try {
                const { data, error } = await supabase
                    .from("hotspot_likes")
                    .select("google_place_id")
                    .eq("user_id", store.state.userData.userId);

                if (error) {
                    console.error("Error fetching UserLikes from Supabase:", error);
                    return;
                }
                let userLikesList = data.map((like) => {
                    return like.google_place_id
                })
                commit('setUserHotspotLikes', userLikesList);
            } catch (error) {
                console.error("An error occurred while fetching UserLikes:", error);
            }
        },
        async getUserContributions({ commit }) {
            try {
                const { data, error } = await supabase
                    .from("community")
                    .select("id, timeframe, short_title, content, url, user_id(id, full_name), location_id(id, name, pic_url, position, pic_att)")
                    .eq("user_id", store.state.userData.userId);

                if (error) {
                    console.error("Error fetching UserContributions from Supabase:", error);
                    return;
                }
                commit('setUserContributions', data);
            } catch (error) {
                console.error("An error occurred while fetching UserLikes:", error);
            }
        },
        async openTopLocationDialog({ commit }, location) {
            commit('loadingOn')

            const { data, error } = await supabase
                .from("stays")
                .select("arrival_date, departure_date, tense, users_data!stays_user_id_fkey(id, full_name, avatar_url, origin_country, facebook_account, instagram_account, email)")
                .eq('tense', 'present')
                .eq('public', 'true')
                .eq('place_id', location.id);
            if (error) {
                console.error("Error fetching PersonalStays from Supabase:", error);
            }
            commit('initLocationDialog', {data, location})
            commit('loadingOff')
        },
        async getTopLocations({ commit }) {
            try {
                const { data, error } = await supabase
                    .from("locations")
                    .select("name, pic_url, pic_att, position, nomad_count, id")
                    .gt("nomad_count", 0);

                if (error) {
                    console.error("Error fetching locations from Supabase:", error);
                    return;
                }

                data.sort((a, b) => b.nomad_count - a.nomad_count);
                commit('getTopLocations', data);
            } catch (error) {
                console.error("An error occurred while fetching locations:", error);
            }
        },
        async getUsers({ commit }) {
            try {
                const { data, error } = await supabase
                    .from("users_data")
                    .select("full_name, avatar_url, id")

                if (error) {
                    console.error("Error fetching users from Supabase:", error);
                    return;
                }

                commit('getUsersList', data);
            } catch (error) {
                console.error("An error occurred while fetching users:", error);
            }
        },
        async getMyLocations({ commit, state }) {
            const { data, error } = await supabase
                .from("stays")
                .select("arrival_date, departure_date, id, tense, locations(id, name, pic_url, position, pic_att)")
                .eq('user_id', state.userData.userId);
            if (error) {
                console.error("Error fetching PersonalStays from Supabase:", error);
            }
            data.sort((a, b) => {
                const dateA = new Date(a.arrival_date);
                const dateB = new Date(b.arrival_date);
                return dateB - dateA;
            });
            let myLocations = []
            data.forEach((stay) => {
                var currentStay = {
                    'arrival_date': stay.arrival_date,
                    'departure_date': stay.departure_date,
                    "id": stay.id,
                    "locationId": stay.locations.id,
                    "locationName": stay.locations.name,
                    "picUrl": stay.locations.pic_url,
                    "position": stay.locations.position,
                    "picAtt": stay.locations.pic_att,
                    "tense": stay.tense
                }
                myLocations.push(currentStay)
            });
            commit('getMyLocations', myLocations);
        },
        async getUserData({ commit }) {
            const user = (await supabase.auth.getUser()).data.user
            const { data, error } = await supabase.from("users_data")
                .select("id, email, full_name, avatar_url, initials, origin_country, facebook_account, instagram_account, privacy_default, current_stay(id, last_updated, arrival_date, departure_date, public, tense, locations(name, position, id))")
                .eq('id', user.id);
            if (error) {
                console.log(error)
            } else {
                commit('getUserData', data)
            }
        },
        async getProfileCardData({ commit }, userId) {
            const { data, error } = await supabase.from("users_data")
                .select("id, email, full_name, avatar_url, origin_country, facebook_account, instagram_account, current_stay(tense, arrival_date, departure_date, public, locations(name))")
                .eq('id', userId);
            if (error) {
                console.log(error)
            } else {
                console.log(data)
                commit('setProfileCardData', data[0])
            }
        },

        async getSocialData({commit}) {
            let groupIds = ['1033016563818566', 'colivings', '1379879762509051', '756306204446638', '325849768974770']
            const { data, error } = await supabase
                .from("gpt_posts")
                .select("id, classification, start_date, end_date, short_title, post_id(post_id, content, date_published, parent_id), location_id(id, name, pic_url, position, pic_att)")
                .neq('location_id', null)
                .neq('classification', 'inquiry')
                .neq('classification', 'general_info_sharing')
                .neq('classification', 'personal_introduction')
                .neq('classification', 'other_category')
                .neq('classification', 'location_info_sharing')
                .eq('display', 'true')
                .eq('is_specific', 'true')
            if (error) {
                console.error("Error fetching SocialData from Supabase:", error);
            }

            // remove data and error vars
            // const { data: socialData, error: socialError } = await supabase
            const { data: communityData, error: communityError } = await supabase
                .from("community")
                .select("id, timeframe, short_title, content, url, user_id(id, full_name), location_id(id, name, pic_url, position, pic_att)")
            if (communityError) {
                console.error("Error fetching SocialData from Supabase:", error);
            }

            console.log(data)
            // commit('setSocialData', data)
            console.log(communityData)
            let normalizedCommunityData = []
            const { data: inquiryData, error: inquiryError } = await supabase
                .from("gpt_posts")
                .select("id, classification, start_date, end_date, short_title, post_id(post_id, content, date_published, parent_id), location_id(id, name, pic_url, position, pic_att)")
                .eq('classification', 'inquiry')
            if (inquiryError) {
                console.error("Error fetching InquiryData from Supabase:", error);
            }

            data.forEach((post) => {
                let normalizedPost = post
                if (post.start_date) {
                    if (post.end_date) {
                        normalizedPost.timeframe = post.start_date + ' - ' + post.end_date
                    } else {
                        normalizedPost.timeframe = post.start_date
                    }
                } else {
                    normalizedPost.timeframe = null
                }

                if (groupIds.includes(post.post_id.parent_id)) {
                    normalizedPost.url = `https://facebook.com/groups/${post.post_id.parent_id}/posts/${post.post_id.post_id}`;
                } else {
                    let grandParentPost = inquiryData.find(item => item.post_id.post_id === post.post_id.parent_id)
                    if (grandParentPost) {
                        normalizedPost.url = `https://facebook.com/groups/${grandParentPost.post_id.parent_id}/posts/${post.post_id.parent_id}`;
                        } else {
                            console.log('no grandparent post found for' + post.post_id.post_id)
                    }
                }
                normalizedPost.content = post.post_id.content

                normalizedCommunityData.push(normalizedPost)
            })
            // normalizedCommunityData.push(...communityData)
            normalizedCommunityData.unshift(...communityData)
            commit('setSocialData', normalizedCommunityData)
        }
    },
    getters: {
        // your getters go here
    }
});
